// libraries.
import { electricPurple600 } from '@habitech/shared';
import { MapContext } from '@react-google-maps/api';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useContext } from 'react';

// slice,
import {
  createPolygon,
  getIsDrawingPolygon,
} from '../store/slices/polygon-slice';
import { polygonRefs } from '../utils';

// drawing engine.
import { usePolygonDrawing } from '../drawing/usePolygonDrawing';
import { DrawingModeHint } from './DrawingModeHint';

const POLYGON_OPTIONS: google.maps.PolygonOptions = {
  fillColor: electricPurple600,
  fillOpacity: 0.5,
  strokeColor: electricPurple600,
  strokeOpacity: 0.8,
  strokeWeight: 2,
};

export const DrawingPolygon = () => {
  const dispatch = useDispatch();
  const isDrawing = useSelector(getIsDrawingPolygon);
  const map = useContext(MapContext) ?? undefined;

  const handlePolygonComplete = useCallback(
    (polygon: google.maps.Polygon, path: google.maps.LatLngLiteral[]) => {
      dispatch(createPolygon({ polygon: path }));
      polygonRefs.push(polygon);
    },
    [dispatch]
  );

  usePolygonDrawing({
    map,
    isActive: Boolean(map && isDrawing),
    polygonOptions: POLYGON_OPTIONS,
    reArmOnComplete: true,
    onPolygonComplete: handlePolygonComplete,
  });

  if (!isDrawing) {
    return null;
  }

  return <DrawingModeHint />;
};
